import React, { useState, useEffect } from 'react';
import { ChevronUpIcon } from '@heroicons/react/outline';

const BackTopBtn = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type='button'
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className='bg-accent hover:bg-accent-hover text-white w-12 h-12 rounded-full fixed right-6 bottom-6 flex justify-center items-center z-40'
      aria-label='Volver arriba'
    >
      <ChevronUpIcon className='w-6 h-6' />
    </button>
  );
};

export default BackTopBtn;
